import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ScoreboardContainer from 'containers/smartguard/ScoreboardContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS, SMARTGUARD_ADMIN_VIEW, SMARTGUARD_SCOREBOARD_VIEW } from 'constants/capabilities';

const SmartguardScoreboardPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/smartguard/scoreboard">&lt; Smartguard</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>


        <ScoreboardContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Smartguard Scoreboard', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, SMARTGUARD_ADMIN_VIEW, SMARTGUARD_SCOREBOARD_VIEW] }),
)(SmartguardScoreboardPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/smartguard/Scoreboard.js